import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../context/auth";

const PublicRoute = ({ component: Component, ...rest }) => {
  const { accessToken, getHome } = useAuth()
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken)
          return Component && <Component {...props} />
        return <Redirect to={getHome()} />
      }}
    />
  );
};

export default PublicRoute;
